import { useTranslation } from "react-i18next";
import { Copy, Share2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { NeuButton } from "../../components/neu/Neu";

export const ShareLinkDialog = ({ open, onOpenChange, link, title }) => {
  const { t } = useTranslation();

  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, text: title, url: link }); } catch { /* cancelled */ }
    } else {
      copy();
    }
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      toast.success(t("acct.dues.share.copied"));
    } catch {
      toast.error("copy_failed");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-3xl" data-testid="share-dialog">
        <DialogHeader>
          <DialogTitle>{t("acct.dues.share.title")}</DialogTitle>
        </DialogHeader>
        <p className="break-all rounded-2xl bg-muted/50 p-3 font-mono text-xs" data-testid="share-link" dir="ltr">
          {link}
        </p>
        <div className="grid grid-cols-2 gap-3">
          <NeuButton onClick={share} data-testid="share-btn">
            <Share2 className="h-4 w-4" />
            {t("acct.dues.share.share")}
          </NeuButton>
          <NeuButton onClick={copy} data-testid="copy-btn">
            <Copy className="h-4 w-4" />
            {t("acct.dues.share.copy")}
          </NeuButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};
